import { cn } from '@/lib/utils';
import { Input, InputNumber, Space } from 'antd';
import type { FC } from 'react';

export interface RangeValue {
  min?: number;
  max?: number;
}

export interface RangeInputProps {
  value?: RangeValue;
  onChange?: (value: RangeValue) => void;
  minPlaceholder?: string;
  maxPlaceholder?: string;
  min?: number;
  max?: number;
  step?: number;
  precision?: number;
  prefix?: string;
  suffix?: string;
  formatter?: (value: number | undefined) => string;
  parser?: (displayValue: string | undefined) => number;
  size?: 'small' | 'middle' | 'large';
  className?: string;
}

export const RangeInput: FC<RangeInputProps> = ({
  value,
  onChange,
  minPlaceholder = 'Min',
  maxPlaceholder = 'Max',
  min,
  max,
  step,
  precision,
  prefix,
  suffix,
  formatter,
  parser,
  size = 'middle',
  className,
}) => {
  return (
    <Space.Compact className={cn('w-full', className)}>
      <InputNumber
        className="w-24"
        placeholder={minPlaceholder}
        min={min}
        max={value?.max}
        step={step}
        precision={precision}
        prefix={prefix}
        suffix={suffix}
        value={value?.min}
        size={size}
        formatter={formatter}
        parser={parser}
        onChange={(newValue) => {
          onChange?.({
            ...value,
            min: newValue ?? undefined,
          });
        }}
      />
      <Input
        className="site-input-split"
        style={{
          width: 30,
          borderLeft: 0,
          borderRight: 0,
          pointerEvents: 'none',
        }}
        placeholder="~"
        disabled
        size={size}
      />
      <InputNumber
        className="w-24"
        placeholder={maxPlaceholder}
        min={value?.min ?? min}
        max={max}
        step={step}
        precision={precision}
        prefix={prefix}
        suffix={suffix}
        value={value?.max}
        size={size}
        formatter={formatter}
        parser={parser}
        onChange={(newValue) => {
          onChange?.({
            ...value,
            max: newValue ?? undefined,
          });
        }}
      />
    </Space.Compact>
  );
};
